import React, { useContext, useEffect, useState } from "react";
import { ProductsList, ContentContainer, Recommendation } from "../../../../../styles/orderform.tsx";
import ProductCard from "./b2cProductCard.tsx";
import { OrderContext } from "../../OrderContext.tsx";
import { getRecommendation } from "../../../../../misc/helpers.ts";

import { styled } from 'styled-components';
import { useAppTranslation } from "../../../../../translations/useAppTranslation.ts";


export const TagsList = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: flex-start;

  button {
    padding: 7px 24px;
  }
`;

function PhaseTwo() {

  const { products, formValues } = useContext(OrderContext);
  const { preferences } = formValues
  const { t, db_t } = useAppTranslation();

  const allTag = { hs_id: 9999, name: 'Kaikki', name_en: 'All' };
  const [selectedTag, setSelectedTag] = useState(allTag);

  const filteredProducts = products
    .filter(product => selectedTag && selectedTag.hs_id != 9999 ? product.tags.some(tag => tag.hs_id === selectedTag.hs_id) : true);

  const uniqueTags = products.reduce((acc, cur) => {
    cur.tags.forEach(tag => {
      if (tag.is_visible_filter && !acc.some(t => t.hs_id === tag.hs_id)) {
        acc.push(tag);
      }
    });
    return acc;
  }, [allTag]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0)
    }
  }, [])

  const suggestedProduct = getRecommendation(preferences, products);

  return (
    <>
      {suggestedProduct && (
        <>
          <ContentContainer>
            <h2>{t('phaseTwo.recommended')}</h2>
          </ContentContainer>
          <Recommendation>
            <ProductCard
              product={suggestedProduct}
              horizontal
            />
          </Recommendation>
        </>
      )}

      <ContentContainer>
        <h3>{t('phaseTwo.otherOptions')}</h3>
        <TagsList>
          {uniqueTags.map(tag => {
            return (
              <button
                key={tag.hs_id}
                type="button"
                className={selectedTag.hs_id === tag.hs_id ? 'primary purple' : undefined}
                onClick={() => setSelectedTag(tag)}>
                {db_t(tag, 'name')}
              </button>
            )
          })}
        </TagsList>

        <ProductsList>
          <div className="products">
            {filteredProducts.map((product) => (
              <ProductCard
                key={product.hs_id}
                horizontal={false}
                product={product}
              />
            ))}
          </div>
        </ProductsList>
      </ContentContainer>
    </>
  )
}

export default PhaseTwo;
